import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DocumentPreview } from "@/components/print/DocumentPreview";
import { usePrintSettings, type PrintSettings } from "@/hooks/usePrintSettings";
import { buildTermPreviewHtml } from "@/lib/print/previewHtml";

type TermPrintPreviewProps = {
  title?: string | null;
  content: string;
  className?: string;
  printSettings?: PrintSettings | null;
};

export function TermPrintPreview({
  title,
  content,
  className,
  printSettings: customPrintSettings,
}: TermPrintPreviewProps) {
  const { t, i18n } = useTranslation("terms");
  const { data: savedPrintSettings } = usePrintSettings();
  const lang = i18n.language === "en" ? "en" : "pt-BR";

  const html = useMemo(
    () =>
      buildTermPreviewHtml({
        printSettings: customPrintSettings ?? savedPrintSettings ?? null,
        title: title ?? "",
        html: content,
        lang,
      }),
    [customPrintSettings, savedPrintSettings, title, content, lang],
  );

  return <DocumentPreview title={t("print.previewTitle")} html={html} className={className} />;
}
